import { useEffect, useState, CSSProperties } from 'react';

type InlineSvgProps = {
    src: string;
    className?: string;
    style?: CSSProperties & Record<string, string | number>; // allow CSS vars
};

export function InlineSvg({ src, className, style }: InlineSvgProps) {
    const [svg, setSvg] = useState<string>('');

    useEffect(() => {
        fetch(src)
            .then((res) => res.text())
            .then((raw) => {
                const colors = new Map<string, string>();
                let index = 1;

                // 1. Replace explicit fill/stroke with CSS vars
                let processed = raw.replace(/(fill|stroke)="([^"]+)"/g, (match, attr, value) => {
                    if (value === 'none') return match; // keep "none"
                    if (!colors.has(value)) {
                        colors.set(value, `--svg-color-${index++}`);
                    }
                    return `${attr}="var(${colors.get(value)}, ${value})"`;
                });

                // 2. Handle paths with no fill/stroke → default to var(--svg-color-1)
                processed = processed.replace(/<path(?![^>]*(fill|stroke)=)/g, `<path fill="var(--svg-color-1, currentColor)"`);

                setSvg(processed);
            });
    }, [src]);

    return <div className={className} style={style} dangerouslySetInnerHTML={{ __html: svg }} />;
}
